import React from "react";

export default function ComponentCard({ project }) {
  return (
    <div className="position-relative">
      <div className="d-flex align-items-center">
        <h5 className="text-black fw-bold">{project.Label}</h5>{" "}
        {project.SolutionUuid && (
          <span className="badge bg-secondary ms-2">Imported</span>
        )}
        {project.IsSolution === true && (
          <span className="badge bg-secondary ms-2">Template</span>
        )}
      </div>
      <div className="text-secondary small">{project.Description}</div>
    </div>
  );
}
